import React, { Component } from 'react'
import {reduxForm, Field, Fields} from 'redux-form'
import { Row, Col} from 'react-bootstrap'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from '../comun/form/InputSelect'
import InputRangeDatePickerDynamicNames from '../comun/form/InputRangeDatePickerDynamicNames'
import { DoneAll, Delete, Launch, Print, AddCircleOutline, FilterList, Warning } from '@material-ui/icons'
import {date_formatter} from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosMovimientoVerraco extends Component {
   constructor () {
    super()
    this.state = {
      openFiltros: false,
      imputSelected: false,
      fitrosSeleccionados: []
    }
  }

  componentDidMount () {
    this.props.actions.comboUbicacion()
    this.props.actions.comboInstalacionPadre({value: null})
  }

  componentDidUpdate (prevProps) {
    if (this.props.movimientoVerraco.datosExcelMovimientoVerraco !== prevProps.movimientoVerraco.datosExcelMovimientoVerraco) {
      if (this.props.movimientoVerraco.datosExcelMovimientoVerraco.excel && this.props.movimientoVerraco.datosExcelMovimientoVerraco.excel !== null){
        let pdf = this.props.movimientoVerraco.datosExcelMovimientoVerraco.excel
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.VERRACOS.MOVIMIENTO_VERRACOS') + ".xlsx")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.movimientoVerraco.datosPdfMovimientoVerraco !== prevProps.movimientoVerraco.datosPdfMovimientoVerraco) {
      if (this.props.movimientoVerraco.datosPdfMovimientoVerraco.pdf && this.props.movimientoVerraco.datosPdfMovimientoVerraco.pdf !== null){
        let pdf = this.props.movimientoVerraco.datosPdfMovimientoVerraco.pdf
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.VERRACOS.MOVIMIENTO_VERRACOS') + ".pdf")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.formSimpleTable && Object.keys(this.props.formSimpleTable).length > 0) {
      if (this.props.formSimpleTable !== prevProps.formSimpleTable) {
        let contActivos = 0
        if (this.props.formSimpleTable.values) {
          Object.values(this.props.formSimpleTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todo', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosMovimientoVerraco()
          }
        }
      }
    }
  }

  fetchFiltrarMovimientoVerraco (values) {
    this.props.actions.fetchFiltrarMovimientoVerraco(values)
  }

  abrirFiltros = (event) => {
    this.setState({ openFiltros: true })
  }

  cerrarFiltros = (event) => {
    this.setState({ openFiltros: false })
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosMovimientoVerraco()
    } else {
      this.props.actions.deSeleccionarTodosMovimientoVerraco()
    }
  }

  deleteSeleccionMovimientoVerraco(){
    const itemsSeleccion = this.props.movimientoVerraco.list.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idUbicacionVerraco': row.idUbicacionVerraco
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionMovimientoVerraco(list)
  }

  crearCsvMovimientoVerraco(){
    this.props.actions.crearCsvMovimientoVerraco(this.props.movimientoVerraco.filtros)
  }

  imprimirPdfMovimientoVerraco(){
    this.props.actions.imprimirPdfMovimientoVerraco(this.props.movimientoVerraco.filtros)
  }

  abrirModalVerracosSinUbicacion (){
    this.props.actions.checkVerracosSinUbicacion()
    this.props.actions.abrirModalVacioUbicacion()
  }

  quitarFiltros (value) {
    let values = this.props.movimientoVerraco.filtros
    values[value] = null
    if (value === 'fechaEntrada') {
      values.movimientoDesde = null
    }
    if (value === 'fechaSalida') {
      values.movimientoHasta = null
    }
    this.props.actions.fetchFiltrarMovimientoVerraco(values)
    this.props.change(value, null)
    this.setState({fitrosSeleccionados: values})
  }

  render () {
  const {
    t, handleSubmit,
    actions: {abrirModalVacioUbicacion},
    combos: {comboVerraco, comboUbicacion},
    movimientoVerraco: {filtros, numVerracosSinUbicacion}
  } = this.props
  console.log(numVerracosSinUbicacion)

  let comboVigenteActual = this.props.combos.comboVigenteActual
  comboVigenteActual = comboVigenteActual.map((actual) => {
    return {...actual, label: t(actual.label)}
  })

  return (
      <div>
        <div className={this.state.openFiltros === true ? 'tabla-filtros open-filters' : 'tabla-filtros'}>
          <form className="custom-form">
            <Field
              colSm={2}
              id="idVerraco"
              name="idVerraco"
              controlLabel={t('MOVIMIENTO_VERRACOS.FILTROS.VERRACO')}
              component={InputSelect}
              options={comboVerraco}
              valueKey="value"
              labelKey="label"
              customClass='select-verraco'
              onInputChange={handleSubmit(this.fetchFiltrarMovimientoVerraco.bind(this))}
            />
            <Field
              colSm={2}
              id="movimientoOrigen"
              name="movimientoOrigen"
              controlLabel={t('MOVIMIENTO_VERRACOS.FILTROS.ORIGEN')}
              component={InputSelect}
              options={comboUbicacion}
              valueKey="value"
              labelKey="label"
              customClass='select-origen'
              onInputChange={handleSubmit(this.fetchFiltrarMovimientoVerraco.bind(this))}
            />
            <Field
              colSm={2}
              id="movimientoDestino"
              name="movimientoDestino"
              controlLabel={t('MOVIMIENTO_VERRACOS.FILTROS.DESTINO')}
              component={InputSelect}
              options={comboUbicacion}
              valueKey="value"
              labelKey="label"
              customClass='select-destino'
              onInputChange={handleSubmit(this.fetchFiltrarMovimientoVerraco.bind(this))}
            />
            <Field
              colSm={2}
              id="actual"
              name="actual"
              controlLabel={t('MOVIMIENTO_VERRACOS.FILTROS.ACTUAL')}
              component={InputSelect}
              options={comboVigenteActual}
              valueKey="value"
              labelKey="label"
              customClass='select-destino'
              onInputChange={handleSubmit(this.fetchFiltrarMovimientoVerraco.bind(this))}
            />
            <Fields
              names={['fechaEntrada', 'fechaSalida']}
              component={InputRangeDatePickerDynamicNames}
              colSm={4}
              nameFrom="fechaEntrada"
              nameTo="fechaSalida"
              controlLabel={t('MOVIMIENTO_VERRACOS.FILTROS.DESDE_HASTA')}
              onInputChange={handleSubmit(this.fetchFiltrarMovimientoVerraco.bind(this))}
            />
            <div className="aplicar-tabla-filtros">
              <div className="filtros-anadidos">
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.idVerraco && filtros.idVerraco !== null ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.VERRACO') + ': ' + filtros.idVerraco.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('idVerraco')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.movimientoOrigen && filtros.movimientoOrigen !== null ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.ORIGEN') + ': ' + filtros.movimientoOrigen.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('movimientoOrigen')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.movimientoDestino && filtros.movimientoDestino !== null ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.DESTINO') + ': ' + filtros.movimientoDestino.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('movimientoDestino')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.actual && filtros.actual !== null ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.ACTUAL') + ': ' + filtros.actual.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('actual')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    (filtros.fechaEntrada && filtros.fechaSalida && filtros.fechaEntrada !== null && filtros.fechaSalida !== null) ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.DESDE_HASTA') + ' ' + t('COMUN.DATE.DESDE') + ': ' + date_formatter(filtros.fechaEntrada, this.props.auth.formaFechaHora, false) + ' - ' + t('COMUN.DATE.HASTA') + ': ' + date_formatter(filtros.fechaSalida, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaSalida')}> x </button></span>
                    ) : (filtros.fechaEntrada && filtros.fechaEntrada !== null) ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.DESDE_HASTA') + ' ' + t('COMUN.DATE.DESDE') + ': ' + date_formatter(filtros.fechaEntrada, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaEntrada')}> x </button></span>
                    ) : (filtros.fechaSalida && filtros.fechaSalida !== null) ? (
                      <span className="badge-dark">{t('MOVIMIENTO_VERRACOS.FILTROS.DESDE_HASTA') + ' ' + t('COMUN.DATE.HASTA') + ': ' + date_formatter(filtros.fechaSalida, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaSalida')}> x </button></span>
                    ) : null
                  )
                }
              </div>
            </div>
          </form>
        </div>
        <Row className="acciones-tabla-filtros">
          <Col sm={10}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.MOVIMIENTO_VERRACOS] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todo"
                    name="seleccionar-todo"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="block-options" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" data-toggle="modal" data-target="#delete-modal" className="btn btn-icono" onClick={(e) => this.deleteSeleccionMovimientoVerraco()}>
                    <Delete></Delete> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <button type="button" className="btn btn-icono" onClick={(e) => this.crearCsvMovimientoVerraco()}>
                  <Launch></Launch> {t('TITULOS_BOTONES.EXPORTAR')}
                </button>
                <button type="button" className="btn btn-icono" onClick={(e) => this.imprimirPdfMovimientoVerraco()}>
                  <Print></Print> {t('TITULOS_BOTONES.IMPRIMIR')}
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#new-edit-modal"
                  className={"btn btn-primary nuevo" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.MOVIMIENTO_VERRACOS] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.MOVIMIENTO_VERRACOS] > 1) ? abrirModalVacioUbicacion : undefined}
                >
                  <AddCircleOutline></AddCircleOutline> {t('TITULOS_BOTONES.NUEVO')}
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#new-edit-modal"
                  className={"btn boton-aviso" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.MOVIMIENTO_VERRACOS] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.MOVIMIENTO_VERRACOS] > 1) ? () => this.abrirModalVerracosSinUbicacion() : undefined}
                >
                  <Warning/>{numVerracosSinUbicacion} {t('MOVIMIENTO_VERRACOS.FILTROS.HAY_NUM_VERRACOS_SIN_UBICACCION')}
                </button>
              </div>
            </div>
          </Col>
          <Col sm={2} className="content-button-filtro">
            <div className="button-group buttons-min button-filtro">
              <div className={this.state.openFiltros === true ? 'btn filters-desp opener-open' : 'btn filters-desp'} onClick={(e) => this.state.openFiltros === false ? this.abrirFiltros() : this.cerrarFiltros()}>
                <FilterList></FilterList> {t('TITULOS_BOTONES.FILTROS')}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'FiltrosMovimientoVerraco',
})(FiltrosMovimientoVerraco))
